export default {
    init() {
        let addVendorPosition;
        let addedSearchVendors = $('.remove').length ? $('.remove').length : '';

        //eslint-disable-next-line no-undef, no-unused-vars
        let vendorSlugs = JSON.parse(currentVendors);

        $(document).ready(function () {
            //Autocomplete
            //eslint-disable-next-line no-undef
            if (typeof vendorsPerProduct !== 'undefined') {
              // eslint-disable-next-line no-undef
                let searchVendors = JSON.parse(vendorsPerProduct).map(function (vendor) {
                    return {'value': vendor.name, 'data': JSON.stringify(vendor)}
                });

                $('#vendor-search').autocomplete({
                    lookup: searchVendors,
                    onSelect: function (suggestion) {
                    //Remove value from input
                        $('#vendor-search').val('');
                        addVendorForCompareHtml(suggestion.data, addVendorPosition);

                       // eslint-disable-next-line no-undef
                        if (addedSearchVendors === 5) {
                            $('#vendor-search').attr('disabled', 'disabled');
                        }
                        addVendorPosition = '';
                    },
                    maxHeight: 300,
                });
            }

            //Vendor Compare - Remove Vendor
            $('.details-table').on('click', 'a.remove', function (e) {
                e.preventDefault();

                let slug = $(this).attr('data-slug');
                removeVendorSlug(slug);
                generateRequestFormFunction();

                let str = $(this).attr('data-id');

              //Add placeholders start
                let logo = '<div class="td add-vendor"><a href="javascript:void(0)"><i class="fa fa-plus-circle"></i>Add a Vendor</a></div>';
              // let td = '<div class="td"></div>';

                $('.logo-row .logo.td[data-name="vendor-' + str +'"]').replaceWith(logo);

              //MATCH SCORE
                $('.match-score-row .td[data-name="vendor-' + str +'"]').text('').removeAttr('data-name');

              //REVIEWS
                $('.reviews-row .td[data-name="vendor-' + str +'"]').text('').removeAttr('data-name');

              //EMPLOYEES
                $('.employees-row .td[data-name="vendor-' + str +'"]').text('').removeAttr('data-name');

              //LIVES SERVICED
                $('.lives-serviced-row .td[data-name="vendor-' + str +'"]').text('').removeAttr('data-name');

              //FUNDING
                $('.funding-row .td[data-name="vendor-' + str +'"]').text('').removeAttr('data-name');

              //GROUP SIZE
                $('.group-size-row .td[data-name="vendor-' + str +'"]').text('').removeAttr('data-name');

              //Features
                $('.features-row .td[data-name="vendor-' + str +'"]').text('').removeAttr('data-name');

              //Top Offerings
                $('.top-offerings-row .td[data-name="vendor-' + str +'"]').text('').removeAttr('data-name');

              //Average Cost
                $('.average-cost-row .td[data-name="vendor-' + str +'"]').text('').removeAttr('data-name');

              //Key Clients
                $('.key-clients-row .td[data-name="vendor-' + str +'"]').text('').removeAttr('data-name');

              //Clients your size
                $('.clients-your-size-row .td[data-name="vendor-' + str +'"]').text('').removeAttr('data-name');

              //Buttons
                $('.request-info-row .td[data-name="vendor-' + str +'"]').text('').removeAttr('data-name');
              //Add placeholders end

                addedSearchVendors--;

                if (addedSearchVendors < 5 && $('#vendor-search').attr('disabled') != undefined) {
                    $('#vendor-search').removeAttr('disabled')
                }
            });

            $('.logo-row').on('click', 'a:not(.remove)', function () {
                $('#vendor-search').focus();

                let clickPosition = $(this).parent();
                addVendorPosition = $('.logo-row .td').index(clickPosition);
            });
        });

    function addVendorForCompareHtml(item, position = '')
    {
        let insertLocation = $('.logo-row .td:not([data-name*="vendor-"]):first');
        let vendorPosition =  $('.logo-row .td').index(insertLocation);
        let insertPosition = position ? position : vendorPosition;
        let vendorDataPosition = insertPosition+1;
        let vendor = JSON.parse(item);

        // eslint-disable-next-line no-unused-vars,no-undef
        addedSearchVendors++;

      //LOGO
        let logoWebsite = '';

        if (vendor.ppc) {
            logoWebsite = '<a href="javascript:;" onclick="ppcClick(' + atob(vendor.ppc_data) + ')" class="external d-flex justify-content-center logo-website">' + vendor.name + ' Website</a>';
        }

        let logoHtml = '' +
        '<div class="td logo" data-name="vendor-' + vendorDataPosition + '">\n' +
        '<div class="logo-wrapper">\n' +
        '<img src="https://d36w3vgtkvgnsp.cloudfront.net/' + vendor.logo + '">\n' +
        '<a href="javascript:void(0)" class="remove" data-slug="' + vendor.slug + '" data-id="' + vendorDataPosition + '">\n' +
        '<i class="fa fa-times-circle"></i>\n' +
        '<span class="sr-only">Remove</span>\n' +
        '</div>\n' +
        '<h3 class="font-size-13 text-center">'+vendor.name+'</h3>\n' +
        logoWebsite +
        '</div>';
        //$('.logo-row .logo.td:not([data-name*="vendor-"]):first').replaceWith(logoHtml);
        $('.logo-row .td').eq(insertPosition).replaceWith(logoHtml);

        //MATCH SCORE
        let matchScore = '<div class="td" data-name="vendor-' + vendorDataPosition + '">- - -</div>';
        $('.match-score-row .td').eq(insertPosition).replaceWith(matchScore);

       //REVIEWS
        let stars = '';
        for (let i=0; i<5; i++) {
            if (vendor.rating <= i) {
                stars += '<i class="fa fa-star inactive"></i>';
            } else {
                stars += '<i class="fa fa-star"></i>';
            }
        }
            let rating = '<span class="rating-count"><strong>' + vendor.rating + '</strong> (' + vendor.num_reviews + ' reviews)</span>';
            let starRating = '<div class="td" data-name="vendor-' + vendorDataPosition + '"><div class="star-rating">' + stars + rating + '</div></div>';
            $('.reviews-row .td').eq(insertPosition).replaceWith(starRating);

          //EMPLOYEES
            let employeesNumber = vendor.num_employees ? vendor.num_employees : (vendor.num_employees_display ? vendor.num_employees_display : 'Not Provided');
            let employees = '<div class="td" data-name="vendor-' + vendorDataPosition + '">' + employeesNumber + '</div>';
            $('.employees-row .td').eq(insertPosition).replaceWith(employees);

          //LIVES SERVICED
            let lives = vendor.lives_serviced_per_year !== 'Not Provided' ? parseInt(vendor.lives_serviced_per_year).toLocaleString('en') : vendor.lives_serviced_per_year
            let livesServiced = '<div class="td" data-name="vendor-' + vendorDataPosition + '">' + lives + '</div>';
            $('.lives-serviced-row .td').eq(insertPosition).replaceWith(livesServiced);

          //FUNDING
            let funding = '<div class="td" data-name="vendor-' + vendorDataPosition + '">' + vendor.funding + '</div>';
            $('.funding-row .td').eq(insertPosition).replaceWith(funding);

          //GROUP SIZE
            let groupSize = vendor.minimum_group_size  && vendor.minimum_group_size > 0 ? vendor.minimum_group_size + ' eligible' : 'No Minimum'
            let groupSizeHTML = '<div class="td" data-name="vendor-' + vendorDataPosition + '">' + groupSize + '</div>';
            $('.group-size-row .td').eq(insertPosition).replaceWith(groupSizeHTML);

          //Features
            let features = '';
            vendor.features.forEach(function (feature) {
                if (feature.name !== null) {
                    features += feature.name + '<br>';
                }
            });
        let featuresHtml = '<div class="td" data-name="vendor-' + vendorDataPosition + '">' + features + '</div>';
        $('.features-row .td').eq(insertPosition).replaceWith(featuresHtml);

      //Top Offerings
        let offerings = '';
        vendor.offerings.forEach(function (offering) {
            if (offering.name !== null) {
                offerings += offering.name + '<br>';
            }
        });
        let offeringsHTMl = '<div class="td" data-name="vendor-' + vendorDataPosition + '">' + offerings + '</div>';
        $('.top-offerings-row .td').eq(insertPosition).replaceWith(offeringsHTMl);

      //Average Cost
        let averageCost = '<div class="td" data-name="vendor-' + vendorDataPosition + '">- - -</div>';
        $('.average-cost-row .td').eq(insertPosition).replaceWith(averageCost);

      //Key Clients
        let keyClients = '<div class="td" data-name="vendor-' + vendorDataPosition + '">- - -</div>';
        $('.key-clients-row .td').eq(insertPosition).replaceWith(keyClients);

      //Clients your size
        let clientsYourSize = '<div class="td" data-name="vendor-' + vendorDataPosition + '">- - -</div>';
        $('.clients-your-size-row .td').eq(insertPosition).replaceWith(clientsYourSize);

      //Buttons
      // eslint-disable-next-line no-undef
        let requestInfo = '<button type="button" href="javascript:void(0)" class="button pricing-info-button" onclick="openRequestInfoPopUp(this, [{\'slug\': \'' + vendor.slug + '\'}], \'' + compareProductSlug + '\', [\'' + vendor.name +  '\'])">Request Info</button>';
        let website = '';

        if (vendor.ppc) {
            website = '<a href="javascript:;" onclick="ppcClick(' + atob(vendor.ppc_data) + ')" class="external">'+vendor.name+' Website</a>';
        }

        let buttons = '<div class="td vendor-buttons" data-name="vendor-' + vendorDataPosition + '">' + requestInfo + website + '</div>'
        $('.request-info-row .td').eq(insertPosition).replaceWith(buttons);

        vendorSlugs.push(vendor.slug);
        generateRequestFormFunction();
    }

    function removeVendorSlug(slug)
    {
        let index = vendorSlugs.indexOf(slug);

        if (index > -1) {
            vendorSlugs.splice(index, 1);
        }
    }

    function generateRequestFormFunction()
    {
        let slug = [];
        vendorSlugs.forEach(function (item) {
            let newSlug = {
                slug: item,
            }

            slug.push(newSlug)
        });

      //eslint-disable-next-line no-undef, no-unused-vars
        let functionAttr = 'openRequestInfoPopUp(this, ' + JSON.stringify(slug) + ', \'' + compareProductSlug + '\')';

        slug.length === 0 ? $('.request-all a').addClass('disabled') : $('.request-all a').removeClass('disabled');
        $('.request-all a').attr('onclick', functionAttr);
    }

    //openRequestInfoPopUp(this, [{"slug":"wellbeats"},{"slug":"virgin-pulse-inc"}], 'wellness-companies')
    //openRequestInfoPopUp(this, [{"slug":"wellbeats"},{"slug":"virgin-pulse-inc"},{"slug":"gilsbar"}], 'wellness-companies')
    //onclick="openRequestInfoPopUp(this, [[{"slug":"wellbeats"},{"slug":"virgin-pulse-inc"},{"slug":"alyfe-wellbeing-strategies"}]], 'wellness-companies')"

    },
    finalize() {
      // JavaScript to be fired on the home page, after the init JS
    },
};
